module.exports = __webpack_public_path__ + "img/top4.ac441988.svg";